<template>
<div id="bitacora_ws" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Administrar Reportes Personalizados" class="elevation-1 px-5 py-3" >
                    <v-card-text>
                        <v-container fluid>
                            <v-row>
                                <v-col cols="12" sm="4" md="4" >
                                    <header>Origen de la Información</header>
                                    <v-radio-group v-model="selected_origen" row @change="onChangeOrigen()" >
                                        <v-radio label="Data Stage" value="DS" ></v-radio>
                                        <v-radio label="Web Service" value="WS" ></v-radio>
                                    </v-radio-group>

                                    <v-autocomplete v-model="selected_nivel1" :items="tablas_n1" @change="onChangeNivel1()" item-text="nombre" item-value="id_tabla" dense multiple clearable outlined small-chips label="Primer Nivel" >
                                    </v-autocomplete>
                                    <v-autocomplete v-if="selected_nivel1.length>0" v-model="selected_nivel2" :items="tablas_n2" @change="onChangeNivel2()" item-text="nombre" item-value="id_tabla" dense clearable outlined persistent-hint small-chips label="Segundo Nivel" >
                                    </v-autocomplete>
                                    <v-autocomplete v-if="tablas_n3.length>0" v-model="selected_nivel3" :items="tablas_n3" @change="onChangeNivel3()" item-text="nombre" item-value="id_tabla"  dense clearable outlined persistent-hint small-chips label="Tercer Nivel" >
                                    </v-autocomplete>
                                    <v-autocomplete v-if="tablas_n4.length>0" v-model="selected_nivel4" :items="tablas_n4" @change="onChangeNivel4()" item-text="nombre" item-value="id_tabla"  dense clearable outlined persistent-hint small-chips label="Cuarto Nivel" >
                                    </v-autocomplete>
                                    <v-autocomplete v-if="tablas_n5.length>0" v-model="selected_nivel5" :items="tablas_n5" @change="onChangeNivel5()" item-text="nombre" item-value="id_tabla"  dense clearable outlined persistent-hint small-chips label="Quinto Nivel" >
                                    </v-autocomplete>

                                    <v-card color="#EEEEEE" v-if="columnas_tablas.length>0" >

                                        <v-card-title>
                                            <header>Agregar Filtro de la Información</header>

                                        </v-card-title>
                                        <v-card-text>
                                         <v-form
                                                ref="form"
                                                v-model="valid"
                                                :lazy-validation="lazy"
                                                >
                                                <v-autocomplete required  :rules="[v => !!v || 'Columna Requerida']"
                                                v-model="model_filtro.campo" :items="columnas_tablas" item-text="nombre" return-object dense outlined label="Campo" >
                                                </v-autocomplete>
                                                <v-autocomplete required :rules="[v => !!v || 'Operador Requerido']" v-model="model_filtro.operador" :items="operadores" item-text="nombre" return-object dense solo >
                                                </v-autocomplete>
                                                <v-text-field :rules="[v => !!v || 'Valor Requerido']" required v-model="model_filtro.valor"
                                                    label="Valor" dense
                                                    outlined
                                                ></v-text-field>
                                                <v-row>
                                                <v-spacer />
                                                <v-col md="5" >
                                                <v-btn :disabled="!valid" x-small @click="agregarFiltro()" v-tippy>
                                                    <v-icon x-small>mdi-filter-plus-outline</v-icon>Agregar
                                                </v-btn>
                                                  </v-col>
                                                  </v-row>
                                         </v-form>
                                        </v-card-text>
                                        <subheader v-if="this.filtro.length>0" >Filtros</subheader>
                                    <div class="filtro" v-for="(element,i) in filtro" :key="i" >
                                      
                                               
                                                
                                                
                                                <v-chip class="ma-2" x-small color="primary" >
                                                    {{element.nombre_campo}}
                                                </v-chip>
                                                <v-chip class="ma-2" x-small color="yellow" >
                                                    {{element.nombre_operador}}
                                                </v-chip>
                                                <v-chip class="ma-2" x-small color="secondary" >
                                                    {{element.valor}}
                                                </v-chip>
                                                <v-btn color="red" icon x-small dark title="Eliminar Filtro" @click="eliminarFiltro(i)" v-tippy>
                                                    <v-icon>mdi-trash-can-outline</v-icon>
                                                </v-btn>
                                               

                                            </div>
                                    </v-card>
                                    
                                </v-col>
                                <v-col cols="12" sm="4" md="4" >
                                    <v-card color="#EEEEEE" min-height="500px" >
                                        <v-card-title class="primary text-white" >Columnas Disponibles
                                            <v-spacer />
                                            <v-btn color="white" fab x-small dark title="Agregar Todas" @click="agregarTodas()" v-tippy>
                                                <v-icon>mdi-playlist-plus</v-icon>
                                            </v-btn>
                                        </v-card-title>

                                        <draggable class="list-group" :list="columnas_filtro" group="campos" min-height="500px" >
                                            <div class="list" v-for="(element, i) in columnas_filtro" :key="element.id_campo" @dblclick="agregarUna(element, i)" >
                                                <v-icon x-small @click="agregarUna(element, i)" >mdi-arrow-right</v-icon>
                                                {{ element.nombre }}

                                            </div>
                                        </draggable>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" sm="4" md="4" >
                                    <v-card color="#EEEEEE" min-height="500px" >
                                        <v-card-title class="secondary text-white" >

                                            Columnas Seleccionadas
                                            <v-spacer />

                                            <v-btn color="white" fab x-small dark title="Eliminar Todas" @click="regresarTodas()" v-tippy>
                                                <v-icon>mdi-playlist-remove</v-icon>
                                            </v-btn>
                                        </v-card-title>

                                        <draggable class="list-group" :list="selected_columnas" group="campos" min-height="500px" >
                                            <div class="list" v-for="(element,i) in selected_columnas" :key="element.id_campo" @dblclick="regresarUna(element, i)" >
                                                <v-icon x-small @click="regresarUna(element, i)" >mdi-arrow-left</v-icon>
                                                {{ element.nombre }}
                                            </div>
                                        </draggable>

                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import draggable from "vuedraggable";

import {
    mapState
} from "vuex";
export default {
    name: "PersonalizadosAdmin",
    components: {
        draggable
    },
    data() {
        return {
            valid: true,
            lazy: false,
            selected_origen: "DS",
            tablas: [],
            columnas: [],
            columnas_filtro: [],
            selected_nivel1: [],
            selected_nivel2: 0,
            selected_nivel3: 0,
            selected_nivel4: 0,
            selected_nivel5: 0,
            columnas_tablas: [],
            tablas_n3: [],
            tablas_n4: [],
            tablas_n5: [],
            actualiza: 0,
            filtro: [],
            selected_columnas: [],
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Administrar",
                    disabled: true,
                    to: ""
                }
            ],
            model_filtro: {
                campo: "",
                operador: "",
                valor: ""

            },
            operadores: [
                {
                    nombre:"Igual a",
                    valor:"="
                },
                {
                    nombre:"Distinto a",
                    valor:"!="
                },
                {
                    nombre:"Menor a",
                    valor:"<"
                },
                {
                    nombre:"Mayor a",
                    valor:" >"
                },
                {
                    nombre:"Menor o Igual a",
                    valor:"<="
                },
                {
                    nombre:"Mayor o Igual a",
                    valor:" >="
                },
            ],
        }
    },
    computed: mapState({
        tablas_origen() {
            var items = this.tablas;
            var result = items.filter(item => item.origen === this.selected_origen);
            return result;
        },
        tablas_n1() {
            var items = this.tablas;
            var result = items.filter(
                item => item.origen === this.selected_origen && item.nivel === 1
            );
            return result;
        },
        tablas_n2() {
            var items = this.tablas;
            var result = items.filter(
                item => item.origen === this.selected_origen && item.nivel === 2
            );
            return result;
        },

    }),
    mounted() {

    },
    created() {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.getTablas();
        this.getColumnas();
    },
    methods: {
        agregarTodas() {

            this.selected_columnas = this.columnas_tablas;
            this.columnas_filtro = [];
        },
        eliminarFiltro(idx) {
            this.filtro.splice(idx, 1);
        },
        agregarFiltro() {
            this.filtro.push({
                id_campo: this.model_filtro.campo.id_campo,
                nombre_campo: this.model_filtro.campo.nombre,
                operador: this.model_filtro.operador.valor,
                nombre_operador: this.model_filtro.operador.nombre,
                valor: this.model_filtro.valor,
            });
        },
        agregarUna(item, idx) {

            this.selected_columnas.push(item);
            this.columnas_filtro.splice(idx, 1);
        },
        regresarTodas() {
            this.columnas_filtro = this.columnas_tablas;
            this.selected_columnas = [];
        },
        regresarUna(item, idx) {
            this.columnas_filtro.push(item);
            this.selected_columnas.splice(idx, 1);
        },
        onChangeOrigen: function () {
            this.columnas_filtro = [];
            this.selected_columnas = [];
            this.selected_nivel1 = [];
            this.columnas_tablas = [];
        },
        onChangeNivel1: function () {
            this.tablas_n3 = [];
            this.tablas_n4 = [];
            this.tablas_n5 = [];
            this.selected_columnas = [];
            this.selected_nivel2 = 0;
            this.selected_nivel3 = 0;
            this.selected_nivel4 = 0;
            this.selected_nivel5 = 0;
            let items = this.columnas;
            let result = items.filter(item => this.selected_nivel1.indexOf(item.tabla) > -1);

            this.columnas_filtro = result;
            this.columnas_tablas = result;

        },
        onChangeNivel2: function () {
            this.tablas_n4 = [];
            this.tablas_n5 = [];
            this.selected_nivel3 = 0;
            this.selected_nivel4 = 0;
            this.selected_nivel5 = 0;
            let items = this.columnas;

            this.selected_columnas = [];
            let result = items.filter(item => this.selected_nivel1.indexOf(item.tabla) > -1 || item.tabla == this.selected_nivel2);
            this.columnas_filtro = result;
            this.columnas_tablas = result;

            let tables = this.tablas;
            result = tables.filter(
                item => item.origen === this.selected_origen && item.nivel === 3 && item.id_tabla_padre == this.selected_nivel2
            );
            this.tablas_n3 = result;

        },
        onChangeNivel3: function () {
            this.tablas_n5 = [];
            this.selected_nivel4 = 0;
            this.selected_nivel5 = 0;
            var items = this.columnas;
            this.selected_columnas = [];
            var result = items.filter(item => this.selected_nivel1.indexOf(item.tabla) > -1 ||
                item.tabla == this.selected_nivel2 ||
                item.tabla == this.selected_nivel3);

            this.columnas_filtro = result;
            this.columnas_tablas = result;

            var items = this.tablas;
            var result = items.filter(
                item => item.origen === this.selected_origen && item.nivel === 4 && item.id_tabla_padre == this.selected_nivel3
            );
            this.tablas_n4 = result;

        },
        onChangeNivel4: function () {
            var items = this.columnas;
            this.selected_nivel5 = 0;

            this.selected_columnas = [];
            var result = items.filter(item => this.selected_nivel1.indexOf(item.tabla) > -1 ||
                item.tabla == this.selected_nivel2 ||
                item.tabla == this.selected_nivel3 ||
                item.tabla == this.selected_nivel4

            );

            this.columnas_filtro = result;
            this.columnas_tablas = result;

            var items = this.tablas;
            var result = items.filter(
                item => item.origen === this.selected_origen && item.nivel === 5 && item.id_tabla_padre == this.selected_nivel4
            );
            this.tablas_n5 = result;

        },
        onChangeNivel5: function () {
            var items = this.columnas;

            this.selected_columnas = [];
            var result = items.filter(item => this.selected_nivel1.indexOf(item.tabla) > -1 ||
                item.tabla == this.selected_nivel2 ||
                item.tabla == this.selected_nivel3 ||
                item.tabla == this.selected_nivel4 ||
                item.tabla == this.selected_nivel5
            );

            this.columnas_filtro = result;
            this.columnas_tablas = result;

        },
        getTablas: function () {
            axios
                .get(this.$hostname + "reportes/reportes_tablas/")
                .then(response => {
                    this.tablas = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getColumnas: function () {
            axios
                .get(this.$hostname + "reportes/reportes_columnas/")
                .then(response => {
                    this.columnas = response.data;
                    this.$root.$dialogLoader.hide();
                })
                .catch(error => {
                    console.log(error);
                    this.$root.$dialogLoader.hide();
                });
        }
    }
};
</script>

<style scoped>
.list {
    position: relative;
    display: block;
    padding: 0.25rem 1.25rem;
    background-color: #fff;
    font-size: small ;
    border: 1px solid rgba(0, 0, 0, 0.125);
}
.filtro {
    position: relative;
    display: block;
    padding: 0.2rem 0.2em;
    background-color: #fff;
    font-size: xx-small;
    border: 1px solid rgba(0, 0, 0, 0.125);
}
</style>
